import { ReactComponent as MenuSvg } from '../../assets/icons/menu.svg';

export default function MenuIcon() {
  return <MenuSvg aria-hidden="true" focusable="false" />;
}
